export default {
  maxHeight: 800,
  searchShow: true,
  searchMenuSpan: 4,
  calcHeight: 100,
  tip: false,
  border: true,
  index: true,
  indexLabel: '序号',
  align: 'center',
  viewBtn: false,
  selection: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  menu: false,
  menuWidth: 100,
  columnBtn: false,
  refreshBtn: false,
  column: [
    {
      label: '停车场',
      type: 'tree',
      prop: 'spaceId',
      search: true,
      searchslot: true,
      hide: true,
      props: {
        label: 'title',
        value: 'key',
      },
      searchSpan: 6,
    },
    {
      label: '停车场',
      prop: 'spaceName',
      width: 150,
    },
    {
      label: '区域',
      prop: 'regionName',
      span: 12,
    },
    {
      label: '车牌号',
      prop: 'carNo',
      search: true,
      width: 100,
      searchSpan: 5,
    },
    {
      label: '车辆类型',
      prop: 'carType',
      width: 100,
    },
    {
      label: '入场时间',
      prop: 'dateRange',
      searchSpan: 9,
      hide: true,
      search: true,
      searchslot: true,
      searchRange: true,
      width: 150,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      label: '入场时间',
      prop: 'inTime',
      width: 150,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      label: '入场图片',
      prop: 'cloudCarImage_intoPark',
      slot: true,
      width: 80
    },
    {
      label: '入场通道名称',
      prop: 'inDeviceName',
    },
    {
      label: '是否出场',
      prop: 'outStatus',
    },
    {
      label: '入场备注',
      prop: 'inMemo',
      width: 300,
    },
    {
      label: '操作类型',
      prop: 'parkEventType',
      disabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=parkEventType',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'string',
    },
  ],
};
